import { PlayersManager } from "./PlayersManager";
import { Player } from "./Player";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { Ball } from "../Ball";

export class MidfielderPlayer extends Player {

    public passBall_px: number;
    public passBall_py: number;

    private ballHeadTranslationTween: Phaser.Tween;
    private ballHeadScaleTween: Phaser.Tween;
    private textureHeadPlay: string;
    private isHeadPlay: boolean;

    constructor(game: Phaser.Game, x: number, y: number, rightPlayer: boolean, playersManager: PlayersManager, movementType: string) {

        super(game, x, y, "" + GameVars.playerID, rightPlayer, movementType);

        var idle_frame_ID: number = (GameVars.playerID - 1) * 6 + 1;
        var idle_blink_frame_ID: number = (GameVars.playerID - 1) * 6 + 2;
        var selected_frame_ID: number = (GameVars.playerID - 1) * 6 + 3;
        var shooting_frame_ID: number = (GameVars.playerID - 1) * 6 + 4;
        var headPlay_frame_ID: number = (GameVars.playerID - 1) * 6 + 5;
        var aiming_frame_ID: number = (GameVars.playerID - 1) * 6 + 6;

        this.textureIdle = "centrocampista_" + GameVars.formatNumberForTextureAtlas(idle_frame_ID);
        this.textureIdleBlink = "centrocampista_" + GameVars.formatNumberForTextureAtlas(idle_blink_frame_ID);
        this.textureSelected = "centrocampista_" + GameVars.formatNumberForTextureAtlas(selected_frame_ID);
        this.textureShooting = "centrocampista_" + GameVars.formatNumberForTextureAtlas(shooting_frame_ID);
        this.textureHeadPlay = "centrocampista_" + GameVars.formatNumberForTextureAtlas(headPlay_frame_ID);
        this.textureAiming = "centrocampista_" + GameVars.formatNumberForTextureAtlas(aiming_frame_ID);

        this.passBall_px = -15;
        this.passBall_py = -60;

        this.shootBall_px = 0;
        this.shootBall_py = 35;

        this.playersManager = playersManager;

        this.ballHeadTranslationTween = null;
        this.ballHeadScaleTween = null;

        this.isHeadPlay = false;

        this.frameName = this.textureIdle;

        this.name = GameConstants.MIDFIELDER_PEG;
    }

    public prepareToPass(ball: Ball): void {

        // este booleano es superfluo
        this.isHeadPlay = true;

        this.update = function (): void {
            if (this.ball.scale.x < 1.1) {
                this.frameName = this.textureHeadPlay;
            } else {
                this.frameName = this.textureIdle;
            }
        };

        this.frameName = this.textureHeadPlay;

        this.ball = ball;
        this.hasReceived = true;

        this.ball.parent.removeChild(this.ball);

        this.ball.x = this.passBall_px;
        this.ball.y = this.passBall_py;

        this.addChild(this.ball);

        // darle un tween a la pelota de arriba a abajo
        this.ballHeadTranslationTween = this.game.add.tween(this.ball);

        this.ballHeadTranslationTween.to({ x: this.passBall_px - 15, y: this.passBall_py - 25 }, 300, Phaser.Easing.Cubic.Out)
            .to({ x: this.passBall_px, y: this.passBall_py }, 300, Phaser.Easing.Cubic.In)
            .delay(80)
            .loop()
            .start();

        this.ballHeadScaleTween = this.game.add.tween(this.ball.scale)
            .to({ x: 1.4, y: 1.4 }, 300, Phaser.Easing.Cubic.Out)
            .to({ x: 1, y: 1 }, 300, Phaser.Easing.Cubic.In)
            .delay(80)
            .loop()
            .start();
    }

    public onPassBall(): void {

        this.isHeadPlay = false;

        // cambiar la funcion update
        this.update = function (): void {
            //
        };

        this.frameName = this.textureIdle;

        this.ballHeadTranslationTween.stop();
        this.ballHeadScaleTween.stop();

        this.ballHeadTranslationTween.pendingDelete = true;
        this.ballHeadTranslationTween = null;
        this.ballHeadScaleTween.pendingDelete = true;
        this.ballHeadScaleTween = null;

        let scaleX: number = this.rightPlayer ? 1 : -1;

        this.scale.setTo(scaleX * 1.25, 1.35);

        // con algo de retraso que es lo que la pelota en empezar a moverse
        this.game.add.tween(this.scale)
            .to({ x: scaleX, y: 1 }, 200, Phaser.Easing.Elastic.In, true, 100);
    }

    public prepareToShoot(): void {

        super.prepareToShoot();

        // hacer rotar la pelota
        this.ball.spin();
    }

    public shootBall(): void {

        super.shootBall();
    }

    public getShootAngle(): number {

        return this.angle + 90;
    }

    public onGamePaused(): void {

        super.onGamePaused();

        if (this.ballHeadTranslationTween) {
            this.ballHeadTranslationTween.pause();
            this.ballHeadScaleTween.pause();
        }
    }

    public onGameResumed(): void {

        super.onGameResumed();

        if (this.ballHeadTranslationTween) {
            this.ballHeadTranslationTween.resume();
            this.ballHeadScaleTween.resume();
        }
    }
}
